// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"617021a2","345":"2c05e265"}[chunkId] + ".chunk.js";
};